import React from 'react'

const DonationHead = () => {
  return (
    <div className='container-fluid w-100 px-5 pt-3'>
      <h1 className='fw-bolder'>Donation</h1>
    </div>
  )
}

export default DonationHead
